import { render } from "./pages-list.vue?vue&type=template&id=31a611a9"
import script from "./pages-list.vue?vue&type=script&lang=js"
export * from "./pages-list.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__